import React from "react";
import "./ExploreEventCardSkeleton.css";

const ExploreEventCardSkeleton = () => {
  return (
    <div className="explore-event-card-skeleton">
      <div className="explore-skeleton explore-skeleton-image" />
      <div className="explore-skeleton explore-skeleton-title" />
      <div className="explore-skeleton explore-skeleton-text" />
      <div className="explore-skeleton explore-skeleton-text short" />
    </div>
  );
};

export default ExploreEventCardSkeleton;
